import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import TextInput from '../../components/form-fields/text.input';
import Button from '../../components/button';
import useApi from '../../hooks/use-api';
import Notice from '../../components/notice';
import {
    API_STATUS_FORBIDDEN,
    API_STATUS_VALIDATION_ERROR, MESSAGE_ACCOUNT_LOCKED_ERROR,
    MESSAGE_IMIS_AUTHENTICATION_ERROR,
} from '../../constants';
import MainContainer from '../containers/main';
import {getCaptchaToken, resetCaptcha} from '../../hooks/use-recaptcha';

const Login = () => {
    const api = useApi();

    const [submitting, setSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [userIsLocked, setUserStatus] = useState(false);

    const [token, setToken] = useState(null);
    const [target, setTarget] = useState(null);

    const setRecaptchaToken = (captchaToken) => {
        setToken(captchaToken);
    };

    useEffect(() => {
        // Submitting is done in use effect, to ensure the recaptcha token is ready
        if (!target || !token) {
            return;
        }
        const params = new URLSearchParams(window.location.search);
        const returnUrl = params.get('returnurl');
        api.loginUser(target.username.value, target.password.value, token, returnUrl).then(({ error: apiError, response }) => {
            if (apiError) {
                const { detail } = apiError;
                setSubmitting(false);
                setTarget(null);
                resetCaptcha();
                let infoMessage;
                switch (apiError.status) {
                case API_STATUS_FORBIDDEN:
                case API_STATUS_VALIDATION_ERROR:
                    if (detail?.detail === 'locked') {
                        infoMessage = MESSAGE_ACCOUNT_LOCKED_ERROR;
                        setUserStatus(true);
                    } else {
                        infoMessage = (<>The username and password combination you entered does not match our system. Please try again or contact us at <a href="mailto:rnzcgp@rnzcgp.org.nz" className="color-green-shade-1 no-underline">rnzcgp@rnzcgp.org.nz</a> if you need help.</>);
                    }
                    break;
                default:
                    infoMessage = MESSAGE_IMIS_AUTHENTICATION_ERROR;
                }
                setErrorMessage((
                    <Notice className="mt-8" color="yellow" icon="exclamation-orange">
                        <p>{ infoMessage }</p>
                    </Notice>
                ));
            } else if (typeof response.redirect_to !== 'undefined' && response.redirect_to) {
                window.location = response.redirect_to;
            } else {
                window.location = '/';
            }
        });
    }, [token]);

    window.setRecaptchaToken = setRecaptchaToken;

    const handleLogin = async (e) => {
        setSubmitting(true);
        setUserStatus(false);
        setErrorMessage(null);
        setTarget(e.target);
        getCaptchaToken();

        e.preventDefault();
    };

    return (
        <MainContainer>
            <>
                <h1>Log in</h1>
                { errorMessage }
                <form method="post" onSubmit={ handleLogin }>
                    <TextInput
                        label="Username or MCNZ number"
                        className="mt-10"
                        name="username"
                        placeholder="Eg. 123456"
                        maxLength={ 50 }
                        required={ true }
                    />
                    <TextInput
                        label="Password"
                        type="password"
                        className="mt-8"
                        name="password"
                        required={ true }
                    />
                    {!userIsLocked && (
                        <Link to="/forgot-your-password/" className="small mt-2">Forgot your password?</Link>
                    )}
                    <Button
                        text="Log in"
                        className="mt-10 block btn btn--primary-orange"
                        disabled={ submitting }
                        loader={ submitting }
                    />
                </form>
                <p className="small mt-10 md:mt-20 color-white-70">
                    Forgot your username or MCNZ number? Or still having trouble?<br />Contact us at <a href="mailto:rnzcgp@rnzcgp.org.nz" className="no-underline"><strong>rnzcgp@rnzcgp.org.nz</strong></a>
                </p>
            </>
        </MainContainer>
    );
};

export default Login;
